export const receiptSortValue = receipt => {
  // Clave materializada desde el chat al ingresar; las correcciones manuales la conservan.
  if (receipt.sort_order !== null && receipt.sort_order !== undefined && Number.isFinite(Number(receipt.sort_order))) return Number(receipt.sort_order);
  for (const raw of [receipt.source_timestamp, receipt.received_at, receipt.created_at]) {
    const value = Date.parse(raw);
    if (Number.isFinite(value)) return value / 1000;
  }
  return 0;
};

export const compareReceiptsNewest = (a, b) => {
  const time = receiptSortValue(b) - receiptSortValue(a);
  if (time) return time;
  const sequence = Number(b.source_sequence || 0) - Number(a.source_sequence || 0);
  if (sequence) return sequence;
  const created = (Date.parse(b.created_at) || 0) - (Date.parse(a.created_at) || 0);
  if (created) return created;
  const left = String(a.id || '');
  const right = String(b.id || '');
  return left === right ? 0 : left < right ? 1 : -1;
};